export const recommendations = [
  {
    title: 'First Rec',
    challenges: [
      { label: '# First' },
      { label: '# Second' },
      { label: '# Third' },
      { label: '# Fourth' },
    ],
  },
  {
    title: 'Second Rec',
    challenges: [
      { label: '# First' },
      { label: '# Second' },
      { label: '# Third' },
      { label: '# Fourth' },
    ],
  },
];

export const ddsData = {
  supplyChainPolicy: 100,
  internalManagment: 20,
  supplyChainIntegrity: 30,
  supplierEngagement: 20,
  grievanceMechanism: 20,
};

export const dds = {
  widgets: {
    subjectDetails: {
      id: 'STK-MT0000101',
      subjectName: 'Gem Corp',
      country: 'CD',
      primaryLocation: null,
      type: 'Buisness Entity',
      legalForm: "Limited partnership",
      selfAssessment: true,
    },
    supplyChainDetails: {
      mineSites: 0,
      suppliers: 0,
      positionInSupplyChain: ['In-country Trader', 'Cooperative'],
      products: ['gold'],
      dueDiligenceSystems: true,
    },
    dds: ddsData,
  },
  options: {
    stakeholderCategoryOptions: [
      {
        "label": {
          "en": "Government",
          "fr": "Gouvernement"
        },
        "value": "government"
      },
      {
        "label": {
          "en": "State Security Forces",
          "fr": "Forces de sécurité étatiques"
        },
        "value": "stateSecurityForces"
      },
      {
        "label": {
          "en": "Non-State Armed Group",
          "fr": "Groupe armé non-étatique"
        },
        "value": "nonStateArmedGroup"
      },
      {
        "label": {
          "en": "Business Entity",
          "fr": "Entité commerciale"
        },
        "value": "corporation"
      },
      {
        "label": {
          "en": "Civil Society",
          "fr": "Société civile"
        },
        "value": "civilSociety"
      },
      {
        "label": {
          "en": "Other Organisation",
          "fr": "Autre Organisation"
        },
        "value": "otherOrganisation"
      },
      {
        "label": {
          "en": "Individual",
          "fr": "Individu"
        },
        "value": "individual"
      },
      {
        "label": {
          "en": "Other",
          "fr": "Autre"
        },
        "value": "other"
      }
    ],
    "positionInMineralSupplyChainOptions": [
      {
        "label": {
          "en": "Mining operator",
          "fr": "Opérateur minier"
        },
        "value": "miningOperator"
      },
      {
        "label": {
          "en": "In-country trader",
          "fr": "Négociant / commerçant local"
        },
        "value": "inCountryTrader"
      },
      {
        "label": {
          "en": "Local trading house",
          "fr": "Maison d'achat locale"
        },
        "value": "localTradingHouse"
      },
      {
        "label": {
          "en": "Mineral processor",
          "fr": "Entité de traitement de minerais"
        },
        "value": "mineralProcessor"
      },
      {
        "label": {
          "en": "Mineral exporter",
          "fr": "Exportateur de minerais"
        },
        "value": "exporter"
      },
      {
        "label": {
          "en": "Mine titleholder",
          "fr": "Titulaire du titre minier"
        },
        "value": "mineTitleholder"
      },
      {
        "label": {
          "en": "In-country transporter",
          "fr": "Transporteur local"
        },
        "value": "inCountryTransporter"
      },
      {
        "label": {
          "en": "International trader",
          "fr": "Commerçant international"
        },
        "value": "internationalTrader"
      },
      {
        "label": {
          "en": "International transporter",
          "fr": "Transporteur international"
        },
        "value": "internationalTransporter"
      },
      {
        "label": {
          "en": "Smelter",
          "fr": "Fonderie"
        },
        "value": "smelter"
      },
      {
        "label": {
          "en": "Refiner",
          "fr": "Raffineur"
        },
        "value": "refiner"
      },
      {
        "label": {
          "en": "Manufacturer",
          "fr": "Fabricant"
        },
        "value": "manufacture"
      },
      {
        "label": {
          "en": "Other",
          "fr": "Autre"
        },
        "value": "other"
      }
    ],
    "mineralOptions": [
      {
        "label": {
          "en": "Tin",
          "fr": "Cassitérite"
        },
        "value": "tin"
      },
      {
        "label": {
          "en": "Tantalum",
          "fr": "Coltan"
        },
        "value": "tantalum"
      },
      {
        "label": {
          "en": "Tungsten",
          "fr": "Wolframite"
        },
        "value": "tungsten"
      },
      {
        "label": {
          "en": "Gold",
          "fr": "Or"
        },
        "value": "gold"
      },
      {
        "label": {
          "en": "Silver",
          "fr": "Argent"
        },
        "value": "silver"
      },
      {
        "label": {
          "en": "Cobalt",
          "fr": "Cobalt"
        },
        "value": "cobalt"
      },
      {
        "label": {
          "en": "Copper",
          "fr": "Cuivre"
        },
        "value": "copper"
      },
      {
        "label": {
          "en": "Nickel",
          "fr": "Nickel"
        },
        "value": "nickel"
      },
      {
        "label": {
          "en": "Zinc",
          "fr": "Zinc"
        },
        "value": "zinc"
      },
      {
        "label": {
          "en": "Lead",
          "fr": "Plomb"
        },
        "value": "lead"
      },
      {
        "label": {
          "en": "Diamonds",
          "fr": "Diamants"
        },
        "value": "diamonds"
      },
      {
        "label": {
          "en": "Gemstones",
          "fr": "Pierres précieuses"
        },
        "value": "gemstones"
      },
      {
        "label": {
          "en": "Mica",
          "fr": "Mica"
        },
        "value": "mica"
      },
      {
        "label": {
          "en": "Other",
          "fr": "Autre"
        },
        "value": "other"
      }
    ],
    stakeholderSubCategoriesOptions: [
      {
        "label": {
          "en": "National Government",
          "fr": "Gouvernement national"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "government"
            ]
          }
        ],
        "value": "nationalGovernment"
      },
      {
        "label": {
          "en": "Local Government",
          "fr": "Gouvernement local"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "government"
            ]
          }
        ],
        "value": "localGovernment"
      },
      {
        "label": {
          "en": "Police",
          "fr": "Police"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "stateSecurityForces"
            ]
          }
        ],
        "value": "police"
      },
      {
        "label": {
          "en": "Military",
          "fr": "Militaires"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "stateSecurityForces"
            ]
          }
        ],
        "value": "military"
      },
      {
        "label": {
          "en": "Illegal Armed Group / Militia",
          "fr": "Groupe / milice armé illégal"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "nonStateArmedGroup"
            ]
          }
        ],
        "value": "militia"
      },
      {
        "label": {
          "en": "Unidentified armed men",
          "fr": "Hommes armés non-identifiés"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "nonStateArmedGroup"
            ]
          }
        ],
        "value": "bandits"
      },
      {
        "label": {
          "en": "Road Blockers",
          "fr": "Coupeurs de route"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "nonStateArmedGroup"
            ]
          }
        ],
        "value": "roadBlockers"
      },
      {
        "label": {
          "en": "Other",
          "fr": "Autre"
        },
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "nonStateArmedGroup"
            ]
          }
        ],
        "value": "otherNonStateArmedGroup"
      },
      {
        "label": {
          "en": "Private limited company",
          "fr": "Société privée à responsabilité limitée"
        },
        "value": "privateCompany",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Public limited company",
          "fr": "Société anonyme à capital public"
        },
        "value": "publicCompany",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "State-owned company",
          "fr": "Société détenue par l'État"
        },
        "value": "stateOwnedCompany",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Cooperative",
          "fr": "Coopérative"
        },
        "value": "cooperative",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Sole proprietorship",
          "fr": "Entreprise individuelle"
        },
        "value": "soleProprietorship",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Statutory corporation",
          "fr": "Corporation statutaire"
        },
        "value": "statutoryCorporation",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Limited partnership",
          "fr": "Partenariat limité"
        },
        "value": "limitedPartnership",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "General partnership",
          "fr": "Partenariat illimité"
        },
        "value": "unlimitedPartnership",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Holding company",
          "fr": "Société de portefeuille"
        },
        "value": "holdingCompany",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Other",
          "fr": "Autre"
        },
        "value": "other",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "corporation"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Local civil society organisation",
          "fr": "Organisation de la société civile locale"
        },
        "value": "localCivilSocietyOrganisation",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilSociety"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "National civil society organisation",
          "fr": "Organisation de la société civile nationale"
        },
        "value": "nationalCivilSocietyOrganisation",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilSociety"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "International NGO",
          "fr": "ONG internationale"
        },
        "value": "internationalNGO",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilSociety"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Faith based groups",
          "fr": "Groupe religieux"
        },
        "value": "faithBasedGroups",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilSociety"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Academics",
          "fr": "Université ou centre de recherche"
        },
        "value": "academics",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilSociety"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Other",
          "fr": "Autre"
        },
        "value": "otherCivilSociety",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilSociety"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Unarmed Civilians",
          "fr": "Civils non-armés"
        },
        "value": "unarmedCivilians",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilians"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Armed Civilians",
          "fr": "Civils armés"
        },
        "value": "armedCivilians",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilians"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Women in Particular",
          "fr": "Femmes en particulier"
        },
        "value": "womenInParticular",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilians"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Children in Particular",
          "fr": "Enfants en particulier"
        },
        "value": "childrenInParticular",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilians"
            ]
          }
        ]
      },
      {
        "label": {
          "en": "Whole Community",
          "fr": "Communauté dans son ensemble"
        },
        "value": "wholeCommunity",
        "filters": [
          {
            "name": "stkCategory",
            "condition": "includes",
            "value": [
              "civilians"
            ]
          }
        ]
      }
    ]
  },
};

